import { render, staticRenderFns } from "./MarketplaceAddProduct.vue?vue&type=template&id=259ed7ee"
import script from "./MarketplaceAddProduct.vue?vue&type=script&lang=js"
export * from "./MarketplaceAddProduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports